import { pingSessionStore } from "../session-store";

const API_TIMEOUT_MS = 800;
const SESSION_STORE_TIMEOUT_MS = 500;

/**
 * GET /health-check: 200 when the API and the session store respond, 503 otherwise.
 */
const healthCheck = async ({ res, api }) => {
  const [apiHealthy, sessionStoreHealthy] = await Promise.all([
    isApiHealthy(api),
    isSessionStoreHealthy(),
  ]);

  res.set("Cache-Control", "no-store");

  if (!apiHealthy) {
    res.status = 503;
    res.body = "API is not healthy";
  } else if (!sessionStoreHealthy) {
    res.status = 503;
    res.body = "Session store is not reachable";
  } else {
    res.body = "I'm alive!";
  }
};

async function isApiHealthy(api) {
  try {
    const response = await api("health-check", {
      signal: AbortSignal.timeout(API_TIMEOUT_MS),
    });
    const body = await response.json();
    return body.success === true;
  } catch (err) {
    console.error(`[health-check] API: ${err.message}`);
    return false;
  }
}

async function isSessionStoreHealthy() {
  if (process.browser) return true;

  try {
    await pingSessionStore(SESSION_STORE_TIMEOUT_MS);
    return true;
  } catch (err) {
    console.error(`[health-check] session store: ${err.message}`);
    return false;
  }
}

export default healthCheck;
